module.exports = __webpack_public_path__ + "static/media/item3.9bd2546f.jpg";